import {
  getMuiTextFieldVariant,
  getStackedFormControlClassName,
} from "@/styles/form-field-variant"

import { TextField as MuiTextField } from "@mui/material"

import type { TextFieldProps } from "./text-field.types"

const applyStackedRootSlotProps = (
  variant: TextFieldProps["variant"],
  slotProps?: TextFieldProps["slotProps"]
): TextFieldProps["slotProps"] => {
  if (variant !== "stacked") {
    return slotProps
  }

  const rootSlot = slotProps?.root

  if (typeof rootSlot === "function") {
    return {
      ...slotProps,
      root: (ownerState) => {
        const resolved = rootSlot(ownerState)

        return {
          ...resolved,
          className: getStackedFormControlClassName(
            "stacked",
            resolved.className
          ),
        }
      },
    }
  }

  return {
    ...slotProps,
    root: {
      ...rootSlot,
      className: getStackedFormControlClassName("stacked", rootSlot?.className),
    },
  }
}

export const TextField = ({ variant, slotProps, ...props }: TextFieldProps) => (
  <MuiTextField
    {...props}
    slotProps={applyStackedRootSlotProps(variant, slotProps)}
    variant={getMuiTextFieldVariant(variant)}
  />
)
